import dayjs, { ConfigType, Dayjs, OpUnitType, QUnitType } from 'dayjs';

export class DayJsDate {
  readonly date: Dayjs;

  constructor(dateString: string) {
    this.date = dayjs(dateString);
  }

  diff(date?: ConfigType, unit?: QUnitType | OpUnitType, float?: boolean): number {
    return this.date.diff(date, unit, float);
  }

  format(template?: string): string {
    return this.date.format(template);
  }

  isBefore(date?: ConfigType, unit?: OpUnitType): boolean {
    return this.date.isBefore(date, unit);
  }

  isAfter(date?: ConfigType, unit?: OpUnitType): boolean {
    return this.date.isAfter(date, unit);
  }

  isMoreThan8Hours(): boolean {
    return dayjs().diff(this.date, 'hour') >= 8;
  }
}
